/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import ShareCardSummaryCategoryTitle from './ShareCardSummaryCategoryTitle';
import ShareCardSummaryGroup from './ShareCardSummaryGroup';

import ShareCardIncludedTypeNames from '../../../../constants/ShareCardIncludedTypeNames';
import ShareCardModel from '../../../../models/ShareCardModel';

import ShareCardSummaryList from './ShareCardSummaryList';
import ContactModel, { ContactModelType } from '../../../../models/ContactModel';
import { ContactRelationshipText, ProviderContactNameSpecialtyText, ProviderContactCurrentText, ContactNameHealthcareProxyText } from '../../../components/ContactSummaryText';
import ContactDetails from '../../../components/ContactDetails';

interface Props {
  shareCard: ShareCardModel;
  contacts: ContactModelType[];
  languageCode: string;
  categoryName: string;
}

const ContactRow: React.FC = (props) => (
  <div style={{ marginBottom: 4 }}>
    {props.children}
  </div>
);

const ShareCardSummaryContacts = (props: Props) => {
  const includedContacts = props.contacts.filter((f) => {
    return props.shareCard.contact.isIncluded(f.id);
  });

  if (includedContacts.length === 0) { return null; }

  return (
    <ShareCardSummaryGroup>
      <ShareCardSummaryCategoryTitle categoryName={props.categoryName} includedValues={ShareCardIncludedTypeNames.all} />

      <ShareCardSummaryList
        items={includedContacts}
        renderItem={(contact: ContactModelType) => {
          return (
            <div>
              {
                ContactModel.isProvider(contact)
                ? (
                  <>
                    <div className="font-body font-color-gsDarkest" style={{ marginBottom: 4 }}>
                      <ProviderContactNameSpecialtyText data={contact} />
                    </div>
                    <div className="font-footnote font-color-gsDark" style={{ marginBottom: 4 }}>
                      <ProviderContactCurrentText data={contact} />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="font-body font-color-gsDarkest" style={{ marginBottom: 4 }}>
                      <ContactNameHealthcareProxyText data={contact} />
                    </div>
                    <div className="font-footnote font-color-gsDark" style={{ marginBottom: 4 }}>
                      <ContactRelationshipText data={contact} />
                    </div>
                  </>
                )
              }

              <div className="font-footnote font-color-gsDark">
                <ContactDetails
                  details={contact.details}
                  Component={ContactRow}
                />
              </div>

              {
                contact.comment && (
                  <div className="font-footnote font-color-gsDark" style={{ marginBottom: 4 }}>
                    {contact.comment}
                  </div>
                )
              }
            </div>
          );
        }}
      />
    </ShareCardSummaryGroup>
  );
};

export default ShareCardSummaryContacts;
